( function( app ) {
  const COMPONENT = {
    init: function() {
      const header = document.querySelector( 'header.navbar' );
      if ( !header ) return;

      let lastSize = null;
      const syncSizing = function() {
        const bottom = header.getBoundingClientRect().bottom;

        let drawerTop = bottom;
        let strips = header.querySelectorAll( '.primary-nav__header-strip' );
        if ( !strips.length ) {
          strips = header.querySelectorAll( ':scope > a:not(.a11y-skip-link)' );
        }
        strips.forEach( function( strip ) {
          if ( strip.offsetHeight > 0 ) {
            drawerTop = Math.min( drawerTop, strip.getBoundingClientRect().top );
          }
        } );

        const ctaStack = document.querySelector( '.primary-nav__mobile-ctas' );
        const ctaStackHeight = ctaStack ? ctaStack.offsetHeight : 0;

        const value = bottom + '|' + drawerTop + '|' + ctaStackHeight;
        if ( value === lastSize ) return;
        lastSize = value;
        document.documentElement.style.setProperty( '--topOffset', bottom + 'px' );
        document.documentElement.style.setProperty( '--navDrawerTop', drawerTop + 'px' );
        document.documentElement.style.setProperty( '--mobileCtaStackHeight', ctaStackHeight + 'px' );
      };

      syncSizing();

      if ( window.ResizeObserver ) {
        const observer = new ResizeObserver( syncSizing );
        observer.observe( header );
        const ctaStack = document.querySelector( '.primary-nav__mobile-ctas' );
        if ( ctaStack ) observer.observe( ctaStack );
      }
      window.addEventListener( 'resize', syncSizing );
      window.addEventListener( 'orientationchange', syncSizing );
      if ( document.fonts && document.fonts.ready ) {
        document.fonts.ready.then( syncSizing );
      }

      $( '.navbar-toggle' ).on( 'toggleAfter', ( event ) => {
        const isActive = window.easyToggleState.isActive( event.target );
        $( '.primary-nav' ).stop( true, true )[isActive ? 'fadeIn' : 'fadeOut']();
        syncSizing();

        if ( !isActive ) {
          $( '.primary-nav .primary-menu-item__link.is-open, .primary-nav [data-toggle-target][aria-expanded="true"]' ).trigger( 'click' );
          $( '.primary-nav .primary-menu-item__menu.is-open' ).removeClass( 'is-open' );
        }
      } );

      document.addEventListener( 'click', ( event ) => {
        const toggle = document.querySelector( '.navbar-toggle' );
        if ( !toggle || !window.easyToggleState || !window.easyToggleState.isActive( toggle ) ) return;
        if ( event.target.closest( '#primary-nav, #mobile-nav-ctas, .navbar-toggle' ) ) return;
        toggle.click();
      } );

      $( '[data-toggle-target]' ).on( 'toggleAfter', ( event ) => {
        const trigger = event.target;
        if ( !trigger.closest( 'header.navbar' ) ) return;

        if ( window.easyToggleState.isActive( trigger ) ) {
          ( trigger.getAttribute( 'data-toggle-target' ) || '' ).split( ',' ).forEach( ( selector ) => {
            const target = document.querySelector( selector.trim() );
            if ( !target ) return;
            target.scrollTop = 0;
            target.querySelectorAll( '*' ).forEach( ( el ) => {
              if ( el.scrollTop ) el.scrollTop = 0;
            } );
          } );
        } else {
          setTimeout( () => {
            let node = trigger.parentElement;
            while ( node && node !== document.body ) {
              if ( node.scrollTop ) {
                node.scrollTop = 0;
                break;
              }
              node = node.parentElement;
            }
          }, 0 );
        }
      } );

      function handleMobileChange( event ) {
        /*
         * Remove any inline display values when the screen changes
         * between mobile and desktop state. This allows the default
         * stylings to kick in and prevent any weird "half mobile half desktop"
         * nav display states that sometimes occur while resizing the browser
         * Also remove any active is-open classes from the toggle and nav to reset
         * its state when switching between screen sizes
         */
        if ( event.matches ) {
          if ( $( '.primary-nav' ).length > 0 ) {
            $( '.primary-nav' ).get( 0 ).style.removeProperty( 'display' );

            $( '.navbar-toggle, .primary-nav, #mobile-nav-ctas' ).removeClass( 'is-open' );
            $( 'button[data-toggle-trigger-off].trigger-off__mobile-only' ).removeAttr( 'data-toggle-trigger-off' );
            $( 'button[data-toggle-outside].outside__mobile-only' ).removeAttr( 'data-toggle-outside' );
          }
        } else {
          $( 'button[data-toggle-outside].outside__desktop-only' ).removeAttr( 'data-toggle-outside' );
          // is mobile
        }
      }

      const mobileSize = window.matchMedia( '(min-width: 768px)' );
      handleMobileChange( mobileSize );
      mobileSize.addEventListener( 'change', handleMobileChange );
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'nav', COMPONENT );
} )( app );
